import React, { useState, useEffect } from 'react';
import Form from '@/shared/ui/Form/Form';
import { useForm } from 'react-hook-form';
import StringInput from '@/shared/ui/Inputs/StringInput';
import Button from '@/shared/ui/Buttons/Button';
import { TestCaseListResponseDTO, TestRunCreateDTO } from '@/shared/api/gen/data-contracts';
import api from '@/shared/api/api';
import useModals from '@/shared/hooks/useModal';
import { useFetch } from '@/shared/hooks/useFetch';
import { CheckboxListInput } from '@/shared/ui/Inputs/CheckboxListInput/CheckboxListInput';

interface ITestRunForm {
    defaultData: Partial<TestRunCreateDTO>;
    onSubmit: (data: TestRunCreateDTO) => any;
    projectID: number;
    onCancel?: () => void;
}

function TestRunForm({ defaultData, onSubmit, projectID, onCancel }: ITestRunForm) {
    const { register, handleSubmit, reset, control } = useForm<TestRunCreateDTO>({ defaultValues: defaultData });
    const { closeModal } = useModals();
    const handleCancel = onCancel ?? closeModal;

    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');

    React.useEffect(() => {
        reset(defaultData, { keepDirty: true, keepTouched: true });
    }, [defaultData]);

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearch(search), 300);
        return () => clearTimeout(timer);
    }, [search]);

    const { data: testCasesRaw } = useFetch(
        () => api.test_cases.getTestcasesApiTestCasesGet({
            project_ref: projectID,
            search: debouncedSearch || undefined,
        }),
        [],
        [projectID, debouncedSearch]
    );

    const choices = (testCasesRaw as TestCaseListResponseDTO[])?.map(tc => ({
        value: tc.id,
        title: tc.title,
        meta: `P${tc.priority}`,
    })) ?? [];

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <h2 className='text-24'>Новый тест</h2>
            <p>Укажи данные по тестируемой версии приложения</p>
            <StringInput label="Тестируемая версия приложения" register={register("version")} />
            <StringInput label="Тестируемая ветка" register={register("branch")} />
            <StringInput label="Тестируемый коммит" register={register("commit")} />
            <p>Укажи тест-кейсы, которые будут тестироваться</p>
            <CheckboxListInput
                name="test_cases_run"
                control={control}
                choices={choices}
                label="Тест-кейсы"
                searchPlaceholder="Поиск по названию..."
                onSearch={setSearch}
            />
            <div className='FormRow'>
                <Button type='submit'>Создать тестовый прогон</Button>
                <Button type="button" onClick={handleCancel}>Отмена</Button>
            </div>
        </Form>
    );
}

export default TestRunForm;
